import '../globalLibraries';
import '../coreLibraries';

// Only import the components we need,
// and do not import other components that load Map,
// because it causes CSS bugs in production.
//
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B
import ReactComponentMounter from '../utils/react-component-mounter';
import ActivityPublic from '../apps/activities/ActivityPublic';
import Microfrontend from '../apps/Microfrontend';

ReactComponentMounter.register({
  ActivityPublic,
  Microfrontend
});
